
export class PageEnum implements IPageEnum {
  name:string;
  title:string;
  is(page:PageEnum) {
    return this.name===page.name;
  }
  constructor(name:string, title?:string) {
    this.name = name;
    this.title = title ? title : this.name;
  }
}

interface IPageEnum {
  name:string;
  title:string;
}

export const PageEnums = {
  loading: new PageEnum('loading'),
  dashboard: new PageEnum('dashboard'),
  feedLandingPage: new PageEnum('Feed'),
  register:new PageEnum('register'),
  mainstageQuestions:new PageEnum('mainstage-questions', 'Mainstage Q&A'),
  custom:new PageEnum('custom'),
  booth:new PageEnum('booth', 'Booth'),
  mainstage:new PageEnum('mainstage', 'Main Stage'),
  biometrics:new PageEnum('biometrics'),
  myCoaching:new PageEnum('my-coaching', 'My Coaching'),
  prizes: new PageEnum('rewards', 'Prizes'),
  headspace: new PageEnum('headspace', 'Headspace'),
  calm: new PageEnum('calm', 'Calm'),
  foodswitch: new PageEnum('foodswitch', 'FoodSwitch'),
  myWellness: new PageEnum('my-wellness'),
  counseling: new PageEnum('counseling', 'Nutrition Counseling'),
  library: new PageEnum('Library'),
  vitabot: new PageEnum('vitabot', 'Vitabot'),
  shopwell: new PageEnum('shopwell', 'ShopWell'),
  quitnow: new PageEnum('QuitNow'),
  login: new PageEnum('login'),
  solutionDetail: new PageEnum('solutionDetail'),
  solutionRegister: new PageEnum('solutionRegister'),
  profile: new PageEnum('profile'),
  badgeHistory: new PageEnum('badge-history'),
  hr: new PageEnum('hr-app'),
}
